export default __webpack_public_path__ + "static/media/0013.9c9ca2e6.jpg";